import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const mainRouters = [
  {
    path: '',
    name: 'Home',
    meta: {
      requiresAuth: true,
      title: '首页',
      code: 'HOME',
      displayPageHeader: false,
    },
    component: () => import('@/views/Home.vue'),
  },
  {
    name: 'AccountSettings',
    path: '/account/settings',
    meta: {
      requiresAuth: false,
      title: '用户设置',
      code: 'ACCOUNT_SETTING',
      displayPageHeader: true,
    },
    component: () => import('@/views/account/Setting.vue'),
  },
];

const sysRouters = [
  {
    path: '/dictionary-management',
    name: 'DictionaryList',
    meta: {
      requiresAuth: true,
      title: '字典管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/dictionary/DictionaryList.vue'),
  },
  {
    path: '/organization',
    name: 'OrganizationList',
    meta: {
      requiresAuth: true,
      title: '组织管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/organization/OrganizationList.vue'),
  },
  {
    path: '/sys-user',
    name: 'SysUserList',
    meta: {
      requiresAuth: true,
      title: '用户管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/user/UserList.vue'),
  },
  {
    path: '/user-password',
    name: 'UserPassword',
    meta: {
      requiresAuth: true,
      title: '密码修改',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/user/UserPassword.vue'),
  },
  {
    path: '/menu',
    name: 'MenuList',
    meta: {
      requiresAuth: true,
      title: '菜单管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/menu/MenuList.vue'),
  },
  {
    path: '/role',
    name: 'RoleList',
    meta: {
      requiresAuth: true,
      title: '角色管理',
      displayPageHeader: true,
    },
    // component: () => import('@/views/sys/role/RoleList.vue'),
    component: () => import('@/views/system/role/RoleList.vue'),
  },
  {
    path: '/log',
    name: 'LogList',
    meta: {
      requiresAuth: true,
      title: '日志管理',
      displayPageHeader: true,
    },
    // component: () => import('@/views/sys/log/LogList.vue'),
    component: () => import('@/views/system/log/LogList.vue'),
  },
  {
    path: '/language',
    name: 'LanguageList',
    meta: {
      requiresAuth: true,
      title: '语言管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/language/LanguageList.vue'),
  },
  {
    path: '/i18n-detail',
    name: 'I18NDetailList',
    meta: {
      requiresAuth: true,
      title: '翻译管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/i18nDetail/I18NDetailList.vue'),
  },
  {
    path: '/constructing-page',
    name: 'ConstructingPage',
    meta: {
      requiresAuth: true,
      title: '页面建设中',
      displayPageHeader: true,
    },
    component: () => import('@/layout/ConstructingPage.vue'),
  },
  {
    path: '/coding-rule',
    name: 'CodingRuleList',
    meta: {
      requiresAuth: true,
      title: '编码规则',
      displayPageHeader: true,
    },
    component: () => import('@/views/sys/codingRule/CodingRuleList.vue'),
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/layout/NotFoundPage.vue'),
  },
];

const bizRouters = [
  {
    path: '/Warning',
    meta: {
      requiresAuth: true,
      title: '预警管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/Warning'),
    name: 'Warning',
  },
  {
    path: '/Expediting',
    meta: {
      requiresAuth: true,
      title: '催单管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/expediting/BizExpeditingList'),
    name: 'Expediting',
  }, {
    path: '/Gps',
    meta: {
      requiresAuth: true,
      title: 'GPS',
      displayPageHeader: true,
    },
    component: () => import('@/views/Gps'),
    name: 'Gps',
  }, {
    path: '/Order',
    meta: {
      requiresAuth: true,
      title: '订单管理 (每分钟同步订单数据)',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/order/OrderList'),
    name: 'Order',
  }, {
    path: '/Permission',
    meta: {
      requiresAuth: true,
      title: '权限管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/Permission'),
    name: 'Permission',
  }, {
    path: '/Report',
    meta: {
      requiresAuth: true,
      title: '报表管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/Report'),
    name: 'Report',
  }, {
    path: '/Role',
    meta: {
      requiresAuth: true,
      title: '角色管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/system/role/RoleList'),
    name: 'Role',
  }, {
    path: '/User',
    meta: {
      requiresAuth: true,
      title: '用户管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/system/user/UserList'),
    name: 'User',
  }, {
    path: '/Menu',
    meta: {
      requiresAuth: true,
      title: '菜单管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/system/menu/MenuList'),
    name: 'Menu',
  }, {
    path: '/Salesman',
    meta: {
      requiresAuth: true,
      title: '商务人员信息管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/salesman/SalesmanList'),
    name: 'Salesman',
  }, {
    path: '/Area',
    meta: {
      requiresAuth: true,
      title: '区域管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/area/AreaList'),
    name: 'Area',
  }, {
    path: '/Province',
    meta: {
      requiresAuth: true,
      title: '省份管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/province/ProvinceList'),
    name: 'Province',
  }, {
    path: '/gpsNo',
    meta: {
      requiresAuth: true,
      title: 'GPS设备编码',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/gpsNo/GpsNoList'),
    name: 'gpsNo',
  }, {
    path: '/WarnReason',
    meta: {
      requiresAuth: true,
      title: '预警原因',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/warnReason/WarnReasonList'),
    name: 'WarnReason',
  }, {
    path: '/Company',
    meta: {
      requiresAuth: true,
      title: '客户配置',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/company/BizCompanyList'),
    name: 'Company',
  }, {
    path: '/Receipt',
    meta: {
      requiresAuth: true,
      title: 'GPS设备管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/Receipt'),
    name: 'Receipt'
  }, {
    path: '/ServiceTask',
    meta: {
      requiresAuth: true,
      title: '催单管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/task/ServiceTask'),
    name: 'Receipt',
  }, {
    path: '/Logistics',
    meta: {
      requiresAuth: true,
      title: '物流管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/business/logistics/Logistics'),
    name: 'Logistics',
  }, {
    path: '/InsideDeal',
    meta: {
      requiresAuth: true,
      title: '内部管理',
      displayPageHeader: true,
    },
    component: () => import('@/views/InsideDeal'),
    name: 'InsideDeal'
  }, {
    path: '/BusinessIncentives',
    meta: {
      requiresAuth: true,
      title: '商务激励',
      displayPageHeader: true,
    },
    component: () => import('@/views/BusinessIncentives'),
    name: 'BusinessIncentives'
  }
];


export default new Router({
  routes: [
    {
      path: '',
      meta: {
        requiresAuth: true,
        title: '',
      },
      component: () => import('@/layout/MainFramework.vue'),
      children: [
        ...mainRouters,
        ...sysRouters,
        ...bizRouters,
      ],
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/login/Login.vue'),
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/test/Test.vue'),
    },
    {
      path: '/express-road',
      name: 'express-road',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/expressRoad/OrderList.vue'),
    },
    {
      path: '/error',
      name: 'error',
      meta: {
        requiresAuth: false,
        title: '',
      },
      component: () => import('@/views/ServerError.vue'),
    },
  ],
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
